import * as Immutable from 'immutable';
import {
  GET_PASSWORD_POLICY_ABORTED,
  GET_PASSWORD_POLICY_REQUESTED,
  GET_PASSWORD_POLICY_COMPLETED,
  GET_PASSWORD_POLICY_FAILED,
  // RESET_PLAN_ISASUB_REQUESTED,
  // RESET_PLAN_ISASUB_COMPLETED,
} from '../../actions/passwordpolicy/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: null,
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PASSWORD_POLICY_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_PASSWORD_POLICY_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_PASSWORD_POLICY_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_PASSWORD_POLICY_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
